import { GUIDE_MODES, type GuideMode } from '@/lib/city-guide/serving'

/*
 * A country or region hub's address: `/{locale}/{mode}-tickets/{place}/`. The mode
 * segment is matched whole against the closed list of modes a hub is served in; whether
 * the place names a hub, and which kind, is the place-hub model's answer
 * (→ invariants.md#url-validity-is-the-stores-answer).
 */

/** `bus-tickets` → `bus`; `undefined` for a segment that names no served hub mode. */
export function placeHubModeOfSegment(segment: string): GuideMode | undefined {
    return GUIDE_MODES.find((mode) => segment === `${mode}-tickets`)
}

/** The hub's slug as the place-hub model keys it (`/bus-tickets/us-ny`), or `undefined`
 *  when the mode segment names no served hub mode. The place segment is carried as
 *  requested. */
export function placeHubSlug(modeSegment: string, place: string): string | undefined {
    const mode = placeHubModeOfSegment(modeSegment)
    return mode === undefined || place === '' ? undefined : `/${mode}-tickets/${place}`
}
